module.exports = "<p>\n  please wait!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/components/loader/loader.component.html
// module id = ../../../../../src/app/components/loader/loader.component.html
// module chunks = main